import CheckIn from ".";

export const checkInRoutes = (data) => {
  const user_role_in_org = data?.selectedOrganization?.verificationData?.role; //promoter||"admin"||"staff"
  const global_routes = [
    {
      path: "/:lang/user/check-in/:eventId",
      title: "Event",
      layout: "frontUserInner",
      routeType: "organization",
      component: CheckIn,
    },
  ];

  return global_routes;
};
